import _ from 'lodash';

class IntTypeValidationService {
  constructor(localStorageService, $state) {
    this.localStorageService = localStorageService;
    this.$state = $state;
  }

  getIntegrationTypes() {
    return this.localStorageService.get('integrationTypes');
  }

  isSsoLaunch() {
    return this.localStorageService.get('ssoLaunch');
  }

  isImpersonating() {
    return this.localStorageService.get('isImpersonating');
  }

  isUnManagedCustomer() {
    return this.isImpersonating() && this.localStorageService.get('impersonatingCustomer') && this.localStorageService.get('impersonatingCustomer').rosterType === 'Manual';
  }

  canView(stateName){
    let state = this.$state.get(stateName);
    let integrationTypeArray = this.getIntegrationTypes();
    let approvedTypes =[];
    if(state.customerRestrictions){
      approvedTypes = state.customerRestrictions();
    }
    let overlap = _.intersection(approvedTypes,integrationTypeArray);

    //@TODO This is added to show assign tab for sso user, there might be a better way to fixit
    const showTabsForSsoEnabledUser = state.customerRestrictions && this.isSsoLaunch();

    //special cases: restrict tools section only to be visible for super-admin and unmanaged customer shouldn't access assignemnts 
    if ((stateName === 'home.tools' && this.isImpersonating())|| (stateName.indexOf('home.assign') > -1 && this.isUnManagedCustomer())) {
      return false;
    } else {
      return(!state.customerRestrictions || (overlap.length>0) || showTabsForSsoEnabledUser);
    }

  }
}

IntTypeValidationService.$inject = ['localStorageService', '$state'];

export default IntTypeValidationService;



// WEBPACK FOOTER //
// ./app/common/intTypeValidation/intTypeValidation.service.js